import axios from 'axios';
import { PARTNERS_API_URL } from '../../constants/urls';

const state = {
    partners: null,
};

const actions = {
    getPartners({ commit }) {
        const host = this.state.context.host;

        axios.get( host + PARTNERS_API_URL , { withCredentials: true })
            .then((result) => {
                commit('partners', result.data);
            })
            .catch((error) => {
                /* eslint-disable no-console */
                console.log(error);
            });
    },
};

const mutations = {
    partners(state, value) {
        state.partners = value;
    },
};

const getters = {
    partners({ partners }) {
        return partners;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/partners.js